import High from "./high.svg";
import Highest from "./highest.svg";
import Medium from "./medium.svg";
import Low from "./low.svg";
import Lowest from "./lowest.svg";
import { IoIosArrowRoundForward } from "react-icons/io";
import IsoToDateTime from "../../../../CommonFunction/IsoDateTime";
import styled from "styled-components";
import AvatarComponent from "../Components/AvatarComponent";
import { FaRegCalendarAlt } from "react-icons/fa";
import moment from "moment";

export function checkPriority(priority) {
  const priorityMap = {
    Highest: Highest,
    High: High,
    Medium: Medium,
    Low: Low,
    Lowest: Lowest,
  };

  if (!priority || !priorityMap[priority]) {
    return null;
  }

  return (
    <img
      className="image-priority"
      src={priorityMap[priority]}
      alt={priority.toLowerCase()}
      style={{ width: "16px" }}
    />
  );
}

export function checkChangedValue(Field_Name, Previous_Data, New_Data) {
  if (Field_Name === "Priority") {
    return (
      <>
        <span className="status from-status">
          {" "}
          {checkPriority(Previous_Data)}
          {Previous_Data ? Previous_Data : "None"}
        </span>
        <IoIosArrowRoundForward className="arrow-icon" />
        <span className="status to-status">
          {" "}
          {checkPriority(New_Data)}
          {New_Data ? New_Data : "-"}
        </span>
      </>
    );
  } else if (Field_Name === "Due_Date" || Field_Name === "Start_Date") {
    return (
      <>
        <span className="status from-status">{Previous_Data ? IsoToDateTime(Previous_Data) : "None"}</span>
        <IoIosArrowRoundForward className="arrow-icon" />
        <span className="status to-status">{New_Data ? IsoToDateTime(New_Data) : "-"}</span>
      </>
    );
  } else {
    return (
      <>
        <span className="status from-status">{Previous_Data ? Previous_Data : "None"}</span>
        <IoIosArrowRoundForward className="arrow-icon" />
        <span className="status to-status">{New_Data ? New_Data : "-"}</span>
      </>
    );
  }
}
const isFutureDate = (date) => {
  return moment(date).isAfter(moment(), "day");
};
const renderDate = (dateString) => {
 
  return moment(dateString).format("DD MMM");
};
const CalendarIcon = ({ date }) => {
  const feature = isFutureDate(date) ? "feature-date" : "past-date";
  
  return (
    <div className={`calendar-icon ${feature}`}>
      <FaRegCalendarAlt className="icon" />
      <span className="date">{renderDate(date)}</span>
    </div>
  );
};

export const TaskFooter = (props) => {
  const { Priority, Assignee, Task_Code, Due_Date } = props;
 
  return (
    <FooterDetails>
      <div className="left-footer">
        <p>{Task_Code}</p>
        {Due_Date ? <CalendarIcon date={Due_Date} /> : null}
      </div>

      <div className="right-foter">
        {Priority ? checkPriority(Priority) : null}

        {Assignee ? <AvatarComponent imgSrc="" fullName={Assignee} clickble={false} /> : null}
      </div>
    </FooterDetails>
  );
};

const FooterDetails = styled.div`
  margin-top: 20px;
  width: 100%;
  /* padding: 10px; */
  height: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;

  // Define priority styles with specific colors
  .left-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .calendar-icon {
      display: flex;
      align-items: center;
      background-color: #f0f0f0;
      border-radius: 5px;
      padding: 2px 4px;
      font-size: 11px;
      font-family: Arial, sans-serif;
      font-weight: 700;

      .icon {
        /* color: #666; */
        margin-right: 5px;
        font-size: 10px;
      }

      .date {
        /* color: #333; */
      }
    }
    .past-date {
      background-color: #ffeceb;
      color: #ae2e24;
    }
    .feature-date {
      color: #44546f;
    }
  }
  .right-foter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .highest {
    color: #ff4136; // Red for the highest urgency
  }
  .image-priority {
    width: 16px;
  }

  .avatar-fallback {
    width: 25px;
    height: 25px;
    font-size: 13px;
  }
`;
